import {
  IAccessibility,
  IAdditionalActivities,
  IGastro,
  IOvernightStay,
  IRecommendationReason,
  IRegion,
  IRouteType,
  ISex,
  ISuitability,
  ITerrain,
  ITripDuration,
  ITripSuggestionStatus,
} from 'src/graphql'

const translations = {
  general: {
    language: {
      cs: 'Čeština',
      en: 'Angličtina',
    },
    format: {
      datetime: 'd.M.yyyy H:mm',
      date: 'd.M.yyyy',
    },
    button: {
      cancel: 'Zrušit',
      close: 'Zavřít',
      back: 'Zpět',
      contactSupport: 'Kontaktovat podporu',
    },
    enum: {
      recommendationReason: {
        [IRecommendationReason.Nearby]: 'Poblíž tebe',
        [IRecommendationReason.Similar]: 'Podobný výlet',
        [IRecommendationReason.SimilarToFavorites]: 'Podobné tvým oblíbeným',
        [IRecommendationReason.MatchesPreferences]: 'Podle tvých preferencí',
        [IRecommendationReason.Popular]: 'Oblíbené',
        [IRecommendationReason.Fresh]: 'Novinka',
        [IRecommendationReason.Curated]: 'Doporučujeme',
      },
      tripLabel: {
        fresh: 'Novinka',
      },
      tripSuggestionStatus: {
        [ITripSuggestionStatus.Reserved]: 'Rezervováno',
        [ITripSuggestionStatus.ContributionSubmitted]: 'Odesláno ke kontrole',
        [ITripSuggestionStatus.Converted]: 'Převedeno na výlet',
      },
      tripDuration: {
        [ITripDuration.ShortWalk]: 'Krátký',
        [ITripDuration.HalfDay]: 'Půldenní',
        [ITripDuration.WholeDay]: 'Celodenní',
        [ITripDuration.Weekend]: 'Víkendový',
      },
      gastro: {
        [IGastro.FineCoffee]: 'Výběrová káva',
        [IGastro.Bistro]: 'Bistro',
        [IGastro.Restaurant]: 'Restaurace',
        [IGastro.Confectionery]: 'Cukrárna',
        [IGastro.ForestBar]: 'Lesní bar',
      },
      suitability: {
        [ISuitability.Stroller]: 'Kočárek',
        [ISuitability.Children]: 'Děti',
        [ISuitability.Dogs]: 'Psi',
      },
      additionalActivities: {
        [IAdditionalActivities.WellnessSauna]: 'Wellness a sauna',
        [IAdditionalActivities.Swimming]: 'Koupání',
        [IAdditionalActivities.Playgrounds]: 'Dětská hřiště',
        [IAdditionalActivities.Castles]: 'Hrady a zámky',
        [IAdditionalActivities.LookoutTowers]: 'Rozhledny',
        [IAdditionalActivities.Picnic]: 'Piknik',
        [IAdditionalActivities.EducationalTrails]: 'Naučné stezky',
      },
      overnightStay: {
        [IOvernightStay.UnderTheSky]: 'Pod širákem',
        [IOvernightStay.Camping]: 'Kemp',
        [IOvernightStay.Shelters]: 'Útulna',
        [IOvernightStay.Hostel]: 'Hostel',
        [IOvernightStay.Pension]: 'Penzion',
        [IOvernightStay.Glamping]: 'Glamping',
        [IOvernightStay.Hotel]: 'Hotel',
      },
      routeType: {
        [IRouteType.Circuit]: 'Okruh',
        [IRouteType.AToB]: 'Jednosměrná',
      },
      accessibility: {
        [IAccessibility.TrainBus]: 'Vlak nebo autobus',
        [IAccessibility.PublicTransport]: 'MHD',
      },
      tripCharacteristics: {
        [ISuitability.Children]: 'Aktivity a místa vhodná pro děti',
        [ISuitability.Dogs]: 'Psí louky nebo možnost občerstvení pro pejsky',
        [ISuitability.Stroller]: 'Sjízdné i s kočárkem',
        [IGastro.Bistro]: 'Občerstvení v bistru',
        [IGastro.Confectionery]: 'Možnost osladit si život v cukrárně',
        [IGastro.ForestBar]: 'Jednoduchá vzpruha v lesním baru',
        [IGastro.FineCoffee]: 'Kavárna s výběrovkou',
        [IGastro.Restaurant]: 'Posezení v restauraci',
        [IRouteType.AToB]: 'Jednosměrná trasa',
        [IRouteType.Circuit]: 'Okružní trasa',
        [IAccessibility.TrainBus]: 'Doprava vlakem nebo autobusem',
        [IAccessibility.PublicTransport]: 'Cesta MHD',
        [IOvernightStay.UnderTheSky]: 'Pod širákem',
        [IOvernightStay.Camping]: 'Kemp',
        [IOvernightStay.Shelters]: 'Útulna',
        [IOvernightStay.Hostel]: 'Hostel',
        [IOvernightStay.Pension]: 'Penzion',
        [IOvernightStay.Glamping]: 'Glamping',
        [IOvernightStay.Hotel]: 'Hotel',
        [IAdditionalActivities.Playgrounds]: 'Po cestě najdeš dětská hřiště',
        [IAdditionalActivities.WellnessSauna]: 'Odpočineš si ve wellness nebo sauně',
        [IAdditionalActivities.Picnic]: 'Místo vhodné pro piknik',
        [IAdditionalActivities.LookoutTowers]: 'Možnost kochat se: rozhledny a vyhlídky',
        [IAdditionalActivities.Swimming]: 'Místo, kde se dá zaplavat',
        [IAdditionalActivities.Castles]: 'Zámek, hrad nebo zřícenina',
        [IAdditionalActivities.EducationalTrails]: 'Trasa s naučnou stezkou',
        [ITerrain.Asphalt]: 'Zpevněná a dobře sjízdná asfaltka',
        [ITerrain.FieldPath]: 'Někde pohoda, někde náročnější cesta polňačkou',
        [ITerrain.Stone]: 'Náročnější terén po kamenité cestě',
        [ITerrain.Mixed]: 'Různorodý terén – na detaily mrkni do popisu trasy',
      },
      terrain: {
        [ITerrain.Asphalt]: 'Asfalt',
        [ITerrain.FieldPath]: 'Polní cesta',
        [ITerrain.Stone]: 'Kamenitá cesta',
        [ITerrain.Mixed]: 'Mix',
      },
      region: {
        [IRegion.CentralBohemian]: 'Středočeský kraj',
        [IRegion.HradecKralove]: 'Královéhradecký kraj',
        [IRegion.Liberec]: 'Liberecký kraj',
        [IRegion.Olomouc]: 'Olomoucký kraj',
        [IRegion.Usti]: 'Ústecký kraj',
        [IRegion.KarlovyVary]: 'Karlovarský kraj',
        [IRegion.MoravianSilesian]: 'Moravskoslezský kraj',
        [IRegion.Pardubice]: 'Pardubický kraj',
        [IRegion.Pilsen]: 'Plzeňský kraj',
        [IRegion.PragueCapital]: 'Praha',
        [IRegion.SouthBohemian]: 'Jihočeský kraj',
        [IRegion.SouthMoravian]: 'Jihomoravský kraj',
        [IRegion.Vysocina]: 'Vysočina',
        [IRegion.Zlin]: 'Zlínský kraj',
      },
      sex: {
        [ISex.M]: 'Muž',
        [ISex.F]: 'Žena',
        unspecified: 'Nechci uvádět',
      },
    },
    validations: {
      required: 'Tohle opravdu potřebujeme vědět',
      phone: 'Neplatné číslo – zkus to prosím znovu',
      email: 'Neplatný e-mail – zkus to prosím znovu',
      url: 'Neplatná URL adresa – zkus to prosím znovu',
      minLength: 'Minimální délka je {minLength} znaků',
      maxLength: 'Maximální délka je {maxLength} znaků',
      isPositive: 'Hodnota musí být kladné číslo',
      isPositiveOrZero: 'Hodnota musí být kladné číslo nebo nula',
      minValue: 'Minimální hodnota je {min}',
      maxValue: 'Maximální hodnota je {max}',
      mapsLink: 'Neplatný odkaz na Mapy.cz',
      matchingPasswords: 'Hesla se neshodují',
      passwordsDifferent: 'Hesla musejí být odlišná',
    },
    error: {
      unexpectedError:
        'Ajaj, nastala neočekávaná chyba. Zkus chvíli počkat a opakovat akci znovu. Pokud se problém bude opakovat, kontaktuj nás prosím.',
      refreshTokenExpired:
        'Na každém treku je bezpečnost na prvním místě. Platí to i na rooute. Proto jsme tě odhlásili – přihlaš se, prosím, znovu.',
    },
  },
  app: {
    pwa: {
      install: {
        title: '<strong>Rooute</strong> na jedno kliknutí?',
        caption: {
          android:
            '<p class="q-my-sm">Přidej si appku na plochu a získáš jednodušší přístup bez spouštění prohlížeče.</p>',
          ios:
            '<p class="q-my-sm">Přidej si appku na plochu a získej jednodušší přístup bez spouštění prohlížeče.</p>' +
            '<p class="q-my-sm">Otevři stránku v prohlížeči Safari. V menu <i class="fa-solid fa-arrow-up-from-square"></i> Sdílet zvol možnost <strong>Přidat na plochu</strong>.</p>',
          notChrome:
            '<p class="q-my-sm">Přidej si rooute na plochu a získej jednodušší přístup bez spouštění prohlížeče.</p>' +
            '<p class="q-my-sm">Škoda, tvůj prohlížeč tuto možnost nepodporuje, ale stačí tuto stránku otevřít v prohlížeči Chrome.</p>',
        },
        confirm: 'Přidat',
      },
      updateAvailable: {
        message: 'Jupí, nová verze aplikace je tu!',
        caption:
          'Stáhni si aktualizaci na nejnovější verzi appky a měj jistotu, že všechno bude šlapat, jak má.',
        download: 'Stáhnout',
        later: 'Později',
      },
      applyUpdate: {
        message: 'Aktualizace je stažená',
        caption: 'Nainstaluj si ji hned teď - opravili jsme v ní chyby a přidali nové funkce.',
        install: 'Naistalovat',
      },
      offline: {
        message: 'Tvoje připojení k internetu se ztratilo',
        caption: 'Dokud se nenajde, aplikace nemůže podávat stopro výkon.',
      },
      error: {
        message: 'Ajaj, něco tady nefunguje',
        caption:
          'A zkoušeli jste to zapnout a vypnout? Tak to zkus. A pokud problém přetrvá, napiš nám',
      },
    },
    seo: {
      description: 'My naplánujeme, tobě stačí vzít a vyrazit ven.',
    },
  },
  layout: {
    public: {
      toWeb: 'Na web',
    },
  },
  component: {
    publicHeader: {
      toApp: 'Do aplikace',
    },
    publicFooter: {
      partnership: {
        title: 'Pojďme spolupracovat',
        text: 'Na tvorbě výletů nebo jinak. Ozvi se na',
      },
      follow: {
        title: 'Sleduj nás',
      },
      important: {
        title: 'Důležité odkazy',
        privacyPolicy: 'Ochrana osobních údajů',
        termsOfService: 'Podmínky použití',
      },
      cookiePreferences: 'Nastavení cookies',
      createdBy: 'Vytvořilo',
    },
    mobileTabMenu: {
      dashboard: 'Nástěnka',
      map: 'Mapa',
      trips: 'Výlety',
      profile: 'Profil',
    },
    userMenu: {
      signOut: 'Odhlásit se',
    },
    articlePreviewItem: {
      goToArticle: 'Přečíst článek',
    },
    feedItem: {
      unpublished: 'Nepublikováno',
      readMore: 'Číst dál',
      shareText: 'Tohle si na rooute musíš přečíst!',
      toast: {
        bookmarkError:
          'Ajaj, článek se nepodařilo přidat do záložek. Zkus to později nebo kontaktuj podporu, pokud problém přetrvá.',
        unbookmarkError:
          'Ajaj, článek se nepodařilo odebrat ze záložek. Zkus to později nebo kontaktuj podporu, pokud problém přetrvá.',
      },
    },
    tripPreviewItem: {
      unpublished: 'Nepublikováno',
      toast: {
        bookmarkError:
          'Ajaj, výlet se nepodařilo přidat do oblíbených. Zkus to později nebo kontaktuj podporu, pokud problém přetrvá.',
        unbookmarkError:
          'Ajaj, výlet se nepodařilo odebrat z oblíbených. Zkus to později nebo kontaktuj podporu, pokud problém přetrvá.',
      },
    },
    tripRating: {
      yourRating: 'Tvoje hodnocení:',
      pending: 'Čeká na schválení',
      deletedUser: 'Smazaný uživatel',
    },
    tripRatingScore: {
      noRating: 'Zatím nehodnoceno',
    },
    onboardingOverlay: {
      first: {
        title: 'Řekni nám, kdo jsi a kam kráčíš, ať ti vybereme výlety na míru',
        city: {
          label: 'Kde žiješ?',
          placeholder: 'Vyhledej město',
          noResults:
            'Tohle neznáme - není v názvu překlep? Pokud se ti nedaří město najít, kontaktuj naši podporu a tuto možnost klidně nech prázdnou.',
        },
        sex: { label: 'Cestuju jako...', placeholder: 'Vyber možnost' },
        age: {
          label: 'Na kolik se cítíš?',
          placeholder: 'Vyber věkové rozmezí',
          '0': 'Méně než 18',
          '18': '18 až 29',
          '30': '30 až 44',
          '45': '45 až 59',
          '60': 'Více než 60',
        },
        submit: 'Pokračovat',
      },
      second: {
        title: 'Buď a nebo? Dej si rozstřel!',
        beverage: {
          label: 'Káva nebo čaj?',
          coffee: 'Káva',
          tea: 'Čaj',
        },
        sleeping: {
          label: 'Spacák nebo hotel?',
          sleepingBag: 'Spacák',
          hotel: 'Hotel',
        },
        transportation: {
          label: 'Hromadná nebo auto?',
          publicTransport: 'Hromadná',
          car: 'Auto',
        },
        travelCompanionPreference: {
          label: 'Sám/a nebo s někým?',
          alone: 'Sám/a',
          withTravelCompanion: 'S někým',
        },
      },
      third: {
        title: 'Vyber výlet přesně podle tvého stylu',
        tripDurations: {
          label: 'Jakou délku výletu preferuješ?',
        },
        tripCharacteristics: {
          label: 'Co je pro tebe důležité?',
          strollerFriendly: 'Vhodné pro kočárky',
          entertainmentForChildren: 'Zábava pro děti',
          dogFriendly: 'Trasa vhodná i pro psy',
          coffeeAndCake: 'Káva a dort',
          gastro: 'Kvalitní gastro',
          interestingActivities: 'Zajímavé aktivity na trase',
        },
      },
      fourth: {
        title: 'Rádi jsme tě poznali – díky za vyplnění!',
        text: 'Teď máme lepší představu o tom, kdo rooute používá a můžeme tak chystat zajímavější obsah tobě na míru.',
        referralSource: {
          label: 'A poslední věc: odkud ses o rooute dozvěděl/a?',
          instagram: 'Instagram',
          searchEngine: 'Vyhledávač',
          recommendation: 'Doporučení',
          other: 'Odjinud',
          cantRemember: 'Nevybavuju si',
          otherPlaceholder: 'Vzpoměň si prosím odkud',
        },
        validations: {
          otherRequired: `Nemůžeš si vzpomenout? Zvol variantu 'Nevybavuju si'.`,
        },
      },
      next: 'Další',
      previous: 'Předchozí',
      finish: 'Dokončit',
    },
    mapFilterControl: {
      label: 'Filtrovat',
    },
  },
  dialog: {
    cookie: {
      title: 'Sušenku na výlet? Vyber, jakou si dáš',
      description:
        'Aby rooute fungovalo, potřebujeme ukládat některá data ve tvém prohlížeči (takzvané cookies). Pro funkčnost aplikace je nejlepší, když vezmeš všechny – nebo si vyber, co nám dáš k dispozici. Ať tak či tak, vše je anonymní a tvoje data chráníme jako oko v hlavě.',
      necessary: {
        label: 'Nezbytná data',
        info: 'Tohle je must-have. Bez těchto dat rooute prostě nefunguje – jde o tvoje přihlášení, nastavení jazyka nebo další základní funkce.',
      },
      analytics: {
        label: 'Analytická data',
        info: 'Rooute neustále zlepšujeme, abychom ti mohli dodávat co nejlepší výlety i články. Díky těmto datům víme, na čem zapracovat a co už teď funguje skvěle. Vše anonymně, žádný Big Brother.',
      },
      marketing: {
        label: 'Marketingová data',
        info: 'Tato data nám pomáhají zjistit, jak fungují naše marketingové snahy – a díky tomu můžeme rooute nabídnout dalším nadšeným výletníkům.',
      },
      diagnostics: {
        label: 'Diagnostická data',
        info: 'Díky těmto datům rychle odhalíme případné chyby a zajistíme tak, že ti rooute šlape na jedničku.',
      },
      acceptNecessary: 'Jen nezbytná data',
      savePreferences: 'Uložit moji volbu',
      showDetails: 'Zobrazit podrobnosti',
      acceptAll: 'Beru všechno',
      moreOn:
        'Slibujeme, že tvoje data nikomu nedáme a pracujeme s nimi co nejbezpečněji. Víc zjistíš v',
      privacyPolicy: 'Ochraně osobních údajů',
    },
    changeCredentials: {
      title: 'Změnit údaje',
      firstname: { label: 'Křestní jméno', placeholder: 'Zadej svoje jméno' },
      lastname: { label: 'Příjmení', placeholder: 'Zadej příjmení' },
      submit: 'Uložit údaje',
      toast: {
        success: 'Hotovo, tvoje údaje jsme změnili.',
        error:
          'Ajaj, problém. Během změny údajů došlo k chybě – zkus to znovu později nebo kontaktuj podporu.',
      },
    },
    changePassword: {
      title: 'Změna hesla',
      oldPassword: { label: 'Aktuální heslo', placeholder: 'Zadej aktuální heslo' },
      newPassword: { label: 'Nové heslo', placeholder: 'Zadej nové bezpečné heslo' },
      submit: 'Změnit heslo',
      toast: {
        success: 'Povedlo se, heslo jsme změnili.',
        error:
          'Ajaj, problém. Během změny hesla došlo k chybě – zkus to znovu později nebo kontaktuj podporu.',
      },
    },
    changeInterests: {
      title: 'Změnit zájmy',
      form: {
        gastro: 'Gastronomie',
        suitableFor: 'Vhodné pro',
        additionalActivities: 'Další aktivity',
        overnightStay: 'Ubytování',
        validations: {
          maxLength: 'Vyber maximálně {length} zájmů',
        },
      },
      submit: 'Uložit zájmy',
      toast: {
        success: 'Hotovo, tvoje zájmy jsme si úspěšně zapamatovali.',
        error:
          'Ajaj, problém. Během změny zájmů došlo k chybě – zkus to znovu později nebo kontaktuj podporu.',
      },
    },
    changeLanguage: {
      title: 'Změnit jazyk',
    },
    changeLocation: {
      title: 'Změnit místo',
      region: 'Kraj',
      location: { label: 'Místo', placeholder: 'Zadej, odkud jsi' },
      submit: 'Uložit místo',
      toast: {
        success: 'Hotovo, tvoje místo jsme úspěšně změnili.',
        error:
          'Ajaj, problém. Během změny místa došlo k chybě – zkus to znovu později nebo kontaktuj podporu.',
      },
    },
    tripFilter: {
      title: 'Vyhledej výlety na míru',
      form: {
        duration: 'Časová náročnost',
        distance: 'Délka výletu',
        type: 'Typ',
        terrain: 'Terén',
        area: 'Lokalita',
        suitability: 'Vhodné pro:',
        accessibility: 'Dostupnost:',
        gastro: 'Gastronomie:',
        additionalActivities: 'Další aktivity',
        overnightStay: 'Možnosti přespání',
      },
      submit: 'Zobrazit výlety ({count})',
      noResults: 'Nic jsme nenašli',
      reset: 'Zrušit filtry',
      mapDisplayMode: {
        label: 'Zobrazit na mapě',
        all: 'Vše',
        trips: 'Výlety',
        suggestions: 'Tipy',
      },
    },
    tripSuitabilityInfo: {
      title: 'Způsobilost trasy',
      [ISuitability.Stroller]: {
        title: 'Sjízdné pro kočárek',
        description:
          'Takto označenou trasu projdeš i s kočárkem (nebo třeba s odrážedlem) – obvykle jde o pevnou lesní cestu nebo asfaltku. Pokud jsme při cestě narazili na překážky, nebo nám sjízdnost jednoduše přišla na hraně, najdeš tuhle informaci v detailu výletu.',
      },
      [ISuitability.Children]: {
        title: 'Vhodné pro děti',
        description:
          'Řadíme sem trasy, které jsou spíš nenáročné, ať už délkou nebo terénem. Často na trase objevíš aktivity, které děti zabaví a sníží počet „kdy už tam budem?“ na minimum.',
      },
      [ISuitability.Dogs]: {
        title: 'Vhodné pro psy',
        description:
          'Na trasách vhodných i pro pejsky najdeš například výběhy a psí louky nebo úseky, kde je možná procházka bez vodítka.',
      },
    },
    tripRating: {
      publicReview: 'Veřejná recenze',
      text: { label: 'Komentář', placeholder: 'Napiš komentář' },
      submit: 'Ohodnotit',
      toast: {
        success: 'Tvoje hodnocení bylo odesláno a čeká na kontrolu.',
        error:
          'Ajaj, problém. Během přidávání hodnocení došlo k chybě – zkus to znovu později nebo kontaktuj podporu.',
        banned:
          'Momentálně nemůžeš přidávat recenze. Kontaktuj podporu, pokud si myslíš, že jde o chybu.',
      },
      validations: {
        noRating: 'Musíš zadat alespoň jednu hvězdičku',
      },
    },
    tripCharacteristics: {
      title: 'Co tě na výletě čeká',
    },
    locationRewardDetail: {
      toSwipe: 'Přetáhni pro vybrání odměny',
      isSwiped: 'Odměna vybrána!',
    },
  },
  page: {
    notFound: {
      title: 'Ups, tahle stránka se asi ztratila na trase.',
      text: 'I to se někdy stává. Stejně jako na výletě, i tady je nejlepší se vrátit a zkusit to znovu jinudy.',
      backToHome: 'Zpátky na hlavní stranu',
    },
    landing: {
      title: 'Ahoj! Jsme rádi, že tě vidíme na rooute!',
      description: 'Tady plánujeme my. A tobě stačí jen vybrat výlet a vyrazit ven.',
      newsletter: {
        success: 'Jupí, to nejlepší z rooute ti dorazí do e-mailu.',
        error:
          'Ajaj, problém. Při přihlašování k odběru novinek došlo k chybě – zkus to znovu později nebo kontaktuj podporu.',
      },
    },
    blog: {
      title: 'Blog',
      description: 'Kurátorský výběr novinek a tipů. Přečti, inspiruj se a vyraz ven.',
      loadMore: 'Načíst další',
      noMoreArticles: 'A je to!\nKaždý týden se tu objevují nové příběhy, tak se brzy vrať.',
      noMoreArticles_notAuthenticated:
        'A je to!\nTady už nové články nejsou, ale spoustu dalších příběhů objevíš na naší Nástěnce. Stačí se přihlásit.',
      signIn: 'Přihlásit se',
    },
    termsOfService: {
      title: 'Všeobecné obchodní podmínky',
    },
    privacyPolicy: {
      title: 'Ochrana osobních údajů',
    },
    signpost: {
      title: 'Ahoj, vítej na rooute!',
      text1:
        'Pokud už jsi součástí komunity nadšených výletníků, přihlas se a koukni, co nového jsme připravili.',
      text2:
        'A pokud se na nové výlety teprve chystáš, nejprve se zaregistruj, ať můžeš vybírat, kam se vydáš příště.',
      signIn: 'Přihlásit se',
      signUp: 'Nemáš účet? Zaregistruj se',
    },
    signIn: {
      title: 'Přihlas se',
      email: { label: 'Email', placeholder: 'Zadej svůj e-mail' },
      password: { label: 'Heslo', placeholder: 'Zadej své heslo' },
      forgottenPassword: 'Zapomněl/a jsi heslo?',
      submit: 'Přihlásit se',
      toast: {
        invalidCredentials: 'Neplatný e-mail nebo heslo.',
        invalidRecaptcha:
          'Ajaj, chyba se vloudila. Nepodařilo se nám ověřit tvoji identitu – zkus to prosím znovu. Pokud se chyba opakuje, zkus zakázat rozšíření (například AdBlock) nebo kontaktuj podporu.',
      },
    },
    signUp: {
      title: 'Zaregistruj se',
      email: { label: 'Email', placeholder: 'Zadej svůj e-mail' },
      submit: 'Odeslat registrační e-mail',
      submitted: 'Potvrzovací e-mail byl odeslán na tvůj email.',
      toast: {
        error:
          'Achjo, problém. Při odesílání potvrzovacího emailu došlo k chybě. Zkus to prosím znovu nebo kontaktuj podporu.',
      },
    },
    finishSignUp: {
      title: 'Dokončení registrace',
      firstname: { label: 'Jméno', placeholder: 'Zadej své jméno' },
      lastname: { label: 'Příjmení', placeholder: 'Zadej své příjmení' },
      password: { label: 'Heslo', placeholder: 'Zadej si bezpečné heslo' },
      passwordConfirmation: { label: 'Potvrzení hesla', placeholder: 'Zadejte heslo znovu' },
      language: { label: 'Jazyk' },
      submit: 'Dokončit registraci',
      toast: {
        success: 'Jupí! Účet jsme úspěšně vytvořili – teď se rovnou přihlas.',
        error:
          'Ajaj, problém. Při registraci došlo k chybě – zkus to znovu později nebo kontaktuj podporu.',
      },
    },
    forgottenPassword: {
      title: 'Zapomenuté heslo',
      email: { label: 'Email', placeholder: 'Zadej svůj e-mail' },
      submitted: 'Instrukce pro obnovení hesla jsme odeslali na tvůj email.',
      submit: 'Chci obnovit heslo',
      back: 'Zpět na přihlášení',
      toast: {
        error:
          'Ajaj, problém. Při obnově hesla došlo k chybě – zkus to znovu později nebo kontaktuj podporu.',
      },
    },
    resetPassword: {
      title: 'Změna hesla',
      password: { label: 'Nové heslo', placeholder: 'Zadej si bezpečené heslo' },
      passwordConfirmation: { label: 'Potvrzení hesla', placeholder: 'Zadej heslo znovu' },
      submit: 'Chci obnovit heslo',
      toast: {
        success: 'Jupí, povedlo se a heslo jsme obnovili. Teď se přihlas novým heslem.',
        error: 'Ajaj, problém. Zkus to znovu později nebo kontaktuj podporu.',
      },
    },
    dashboard: {
      title: 'Výletní inspirace',
      latest: 'Nejnovější články',
      noArticlesFound:
        'Kdyby se někde neztratily, už by tu byly. No jo, mluvíme o našich článcích. Tak se vrať za chvíli a oni se určitě zase najdou.',
    },
    articleDetail: {
      featuredArticles: 'Doporučené články:',
      notAvailable: 'Tento článek je dostupný pouze v češtině',
      switchLanguage: 'Zobrazit v češtině',
      backToBlog: 'Zpět na blog',
      confirmBookmark: {
        title: 'Uložit článek',
        description: 'Chceš uložit tento článek do záložek?',
        confirm: 'Uložit',
      },
    },
    map: {
      title: 'Mapa',
      layer: {
        outdoor: 'Turistická',
        basic: 'Základní',
        winter: 'Zimní',
        aerial: 'Letecká',
      },
      popup: {
        here: {
          text: 'Jsi tady',
        },
        goToTrip: 'Prohlédnout výlet',
        suggestion: {
          available: 'Volné',
          reserved: 'Rezervováno',
          viewDetail: 'Zobrazit detail',
        },
      },
    },
    trips: {
      title: 'Výlety',
      recommended: 'Doporučujeme',
      noTripsFound: 'Achjo, žádné výlety se nám tady nepodařilo najít.',
      header: {
        sort: {
          publishedAt: 'Nejnovější',
          finishedCount: 'Nejnavštěvovanější',
          averageRating: 'Nejlépe hodnocené',
        },
      },
    },
    tripDetail: {
      characteristics: 'Co tě na výletě čeká:',
      tripDescription: 'Podrobný itinerář trasy:',
      partnerLocations: 'Ověřená místa na trase:',
      rating: {
        title: 'Hodnocení:',
        noRatings: 'Zatím nikdo nehodnotil. Buď první!',
        showAll: 'Všechny recenze',
      },
      rate: 'Ohodnoť',
      similarTrips: 'Tohle by tě taky mohlo bavit',
      markFinished: 'Označit jako prošlápnutý',
      removeFinished: 'Zrušit prošlápnutí',
      support: 'Trasa neodpovídala popisu? Dej nám vědět',
      toast: {
        toggledFinished:
          'Hurá, výlet teď najdeš v profilu v sekci <strong>Prošlápnuté výlety</strong',
      },
      confirmFavorite: {
        title: 'Přidat do oblíbených',
        description: 'Chceš přidat tento výlet do oblíbených?',
        confirm: 'Přidat do oblíbených',
      },
      confirmFinished: {
        title: 'Označit jako prošlápnutý',
        description: 'Chceš označit tento výlet jako prošlápnutý?',
        confirm: 'Označit jako prošlápnutý',
      },
      notAvailable: 'Tento výlet je dostupný pouze v češtině',
      switchLanguage: 'Zobrazit v češtině',
      backToTrips: 'Zpět na výlety',
    },
    profile: {
      title: 'Profil',
      header: {
        locationUnknown: 'Všudezdejší',
      },
      tiles: {
        totalKm: {
          title: 'Celkem nachozeno',
        },
        rewards: {
          title: 'Získané odměny',
        },
        tripCount: {
          title: 'Prošlápnutých výletů',
        },
      },
      bookmarkedTrips: 'Výlety, co tě chytly za srdce ({val})',
      bookmarkedArticles: 'Články uložené na později ({val})',
      finished: 'Seznam prošlápnutých výletů ({val})',
      tripSuggestions: 'Moje tipy na výlety',
      rewards: 'Nasbírané odměny ({val})',
    },
    settings: {
      title: 'Nastavení',
      credentials: 'Osobní údaje',
      password: 'Změna hesla',
      interests: { title: 'Zájmy', none: 'Žádné' },
      subscription: 'Předplatné',
      location: 'Místo',
      language: 'Jazyk',
      support: 'Kontaktovat podporu',
      deleteAccount: 'Smazat účet',
      about: 'O aplikaci',
      privacyPolicy: 'Ochrana osobních údajů',
      termsOfService: 'Všeobecné podmínky užívání',
      share: {
        label: 'Sdílet s přáteli',
        shareApp: {
          title: 'Vyzkoušej aplikaci rooute',
          text: 'Neplánuj – vyber výlet a vyraz ven',
        },
      },
      signOut: 'Odhlásit se',
      version: 'Verze: {version}',
    },
    bookmarkedArticles: {
      title: 'Uložené články',
      notFound:
        'Zatím tu není ani jeden uložený článek. Mrkni na nástěnku a ulož si čtení na později.',
    },
    finishedTrips: {
      title: 'Prošlápnuté výlety',
      notFound:
        'Tik, ťak - není čas vyrazit ven? Nazuj boty, prošlápni trasu a nezapomeň ji pak označit, ať vidíš, co všechno už máš za sebou.',
    },
    favoriteTrips: {
      title: 'Oblíbené výlety',
      notFound:
        'Dream big! Vyber výlety, které chceš prošlápnout, a ulož si je, ať je snadno najdeš, až přijde jejich čas',
    },
    tripSuggestionDetail: {
      by: 'Od:',
      description: 'Popis',
      viewRoute: 'Zobrazit trasu',
      reserveSuccess: 'Tip na výlet byl úspěšně rezervován!',
      reserveError: 'Nepodařilo se rezervovat tip na výlet.',
      cancelSuccess: 'Rezervace byla zrušena.',
      cta: {
        availableTitle: 'Chceš tento výlet projít?',
        availableDescription:
          'Rezervuj si tento tip a budeš mít {days} dní na to, abys trasu prošel/prošla, nafotil/a a sepsal/a.',
        reserve: 'Rezervovat',
        reservedByMeTitle: 'Máš to rezervované!',
        daysRemaining: 'Zbývá {days} dní na dokončení.',
        startContributing: 'Začít přispívat',
        cancelReservation: 'Zrušit rezervaci',
        underReviewTitle: 'Tvůj příspěvek se kontroluje',
        underReviewDescription: 'Díky za odeslání! Redakce tvůj příspěvek brzy zkontroluje.',
        reservedByOtherTitle: 'Aktuálně rezervováno',
        reservedByOtherDescription:
          'Tento tip je právě rezervován jiným uživatelem. Zkus to později.',
        multipleTitle: 'Podělte se o svůj zážitek z trasy',
        multipleDescription:
          'K tomuto tipu na výlet může přispět kdokoliv. Projděte trasu, nafoťte a podělte se o svůj zážitek.',
        contribute: 'Přispět',
        alreadyContributed: 'Už jste přispěli',
      },
    },
    tripSuggestionContribute: {
      title: 'Přispět k výletu',
      daysRemaining: 'Zbývá {days} dní',
      contentLabel: 'Popis výletu – tvoje zkušenost z trasy',
      suggestionDescription: 'Co od tebe potřebujeme:',
      routeLinkLabel: 'Odkaz na trasu (mapy.cz)',
      routeLinkRequired: 'Odkaz na trasu je povinný',
      imagesLabel: 'Fotky z výletu',
      imagesHint:
        'Kvalitní fotky pomáhají ostatním cestovatelům objevovat skvělé trasy. Použij prosím fotky ve vysokém rozlišení (min. 1500px na šířku, max 10 MB).',
      imagesRequired: 'Přidej alespoň 5 fotek',
      imageUploadError: 'Nepodařilo se nahrát obrázek',
      imageFileTooLarge: 'Soubor je příliš velký (max 10 MB)',
      imageInvalidWidth:
        'Tento obrázek má jen {width}px na šířku. Potřebujeme alespoň {minWidth}px, aby vypadal skvěle pro všechny.',
      submit: 'Odeslat příspěvek',
      confirmTitle: 'Odeslat příspěvek?',
      confirmMessage: 'Tvůj příspěvek bude odeslán redakci ke kontrole. Pokračovat?',
      success: 'Příspěvek byl úspěšně odeslán!',
    },
    myTripSuggestions: {
      title: 'Moje tipy na výlety',
      tabReserved: 'Rezervované',
      tabContributed: 'Přispěno',
      empty: 'Zatím nemáš žádné tipy na výlety',
      emptyDescription: 'Podívej se na mapu a rezervuj si tip na výlet, který tě zajímá.',
      emptyContributed: 'Zatím žádné příspěvky',
      emptyContributedDescription: 'Najdi tip na výlet a podělte se o svůj zážitek.',
      daysRemaining: 'Zbývá {days} dní',
    },
    deleteAccount: {
      seoTitle: 'Smazání účtu',
      title: 'Každý výlet někdy končí…',
      subtitle:
        '… ale někdy je to jenom špatně značená trasa nebo slunce za mrakem, co ti kazí výšlap.',
      text: 'Pokud ti na rooute něco nevyhovuje, nech nám vzkaz – a třeba překážku na trase odstraníme dřív, než naše společná cesta doopravdy skončí.',
      feedback: {
        text: 'Napiš nám a my uděláme maximum pro to, aby tvoje výletování s námi bylo co nejlepší.',
        sendFeedback: 'Poslat feedback',
        placeholder: 'Tady nech vzkaz, sdílej svoji zkušenost nebo nápad, co můžeme vylepšit:',
        submit: 'Odeslat',
      },
      deletion: {
        info: 'Pokud tvoje výletování s rooute opravdu končí, tvůj účet smažeme a s ním i všechny uložené výlety, články a nastavení. Tvoje recenze zůstanou na mapě, ale bez tvého jména – jako anonymní stopa pro ostatní cestovatele.',
        question: 'Chceš opravdu ukončit naši společnou cestu?',
        delete: 'Ano, smažte můj účet na rooute',
        stay: 'Ukecali jste mě, ještě zůstanu',
      },
      toast: {
        title: 'Třikrát hurá! Díky, že dáváš rooute ještě šanci.',
        text: 'Pokud máš nápad, jak rooute vylepšit nebo ti něco nefunguje, napiš nám na {email} – uděláme maximum, aby se ti dobře výletovalo.',
        text2: 'A teď už zpátky na trasu!',
        backToApp: 'Mrknout do appky a vybrat nový výlet',
      },
    },
    partnerLocationDetail: {
      rewards: 'Odměny na tomto místě:',
    },
  },
}

export default translations
